(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["merken"] && !Shopify.designMode) return;
  try {
    
(function() {
  var searchInput = document.getElementById('merken-search');
  var items = Array.prototype.slice.call(document.querySelectorAll('.merken__brand-item'));
  var groups = Array.prototype.slice.call(document.querySelectorAll('.merken__group'));
  var filters = Array.prototype.slice.call(document.querySelectorAll('[data-merk-filter]'));
  var empty = document.getElementById('merken-empty');

  function activeCategories() {
    return filters.filter(function(f) { return f.checked; })
                  .map(function(f) { return f.getAttribute('data-merk-filter'); });
  }

  function apply() {
    var query = searchInput ? searchInput.value.toLowerCase().trim() : '';
    var active = activeCategories();
    var anyVisible = false;

    items.forEach(function(item) {
      var name = item.textContent.toLowerCase();
      var cats = (item.getAttribute('data-category') || '').split(' ');
      var matchesSearch = !query || name.indexOf(query) !== -1;
      var matchesCat = active.length === 0 || active.some(function(c) { return cats.indexOf(c) !== -1; });
      var show = matchesSearch && matchesCat;
      item.hidden = !show;
      if (show) anyVisible = true;
    });

    groups.forEach(function(group) {
      var visible = group.querySelectorAll('.merken__brand-item:not([hidden])');
      group.hidden = visible.length === 0;
    });

    if (empty) empty.hidden = anyVisible;
  }

  if (searchInput) searchInput.addEventListener('input', apply);
  filters.forEach(function(f) { f.addEventListener('change', apply); });
})();

  } catch(e) { console.error(e); }
})();
})();
